import challengesGetters from "./getters.js";
import challengesMutations from "./mutations.js";
import challengesActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      challengesLoaded: null,
      challenges: [],
      submissions: [],
    };
  },
  getters: challengesGetters,
  mutations: challengesMutations,
  actions: challengesActions,
};
